import { Box, Container } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { useNavigate, generatePath } from "../../../router-utils"
import { MergeLeadChannels } from "../../../LeadChannels"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function MergeLeadChannelsPage() {
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>Merge Lead Channels</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<Breadcrumbs
					title="Merge Lead Channels"
					items={[
						[generatePath("/org/lead-channels"), "Lead Channels"],
						["", "Merge"],
					]}
				/>
				<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
					<Box maxWidth="6xl" marginX="auto">
						<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
							<Container paddingY="6">
								<MergeLeadChannels
									onSuccess={() => navigate("/org/lead-channels")}
									onCancel={() => navigate("/org/lead-channels")}
								/>
							</Container>
						</Box>
					</Box>
				</Box>
			</ForbidUnlessAuthorized>
		</>
	)
}
